<template>
  <div class="PageMyReservationForm">
    <el-row :gutter="24">
      <el-col :span="12">
        <h2>{{ $t("pages.wording.reserve") }}</h2>
        <!--我的預約單-->
      </el-col>
      <el-col :span="12">
        <div v-if="parent" class="buttons c-form">
          <el-button class="blue-button button-right" @click="back" type="primary">{{
            $t("pages.button.back")
          }}</el-button
          ><!--關閉-->
        </div>
      </el-col>
    </el-row>
    <el-form ref="dynamicValidateForm" :model="dynamicValidateForm" label-width="120px">
      <el-collapse v-model="activeShowBlock">
        <el-collapse-item class="collapsecontent" name="basic">
          <template slot="title">
            <h3>{{ $t("pages.wording.basisInfo") }}</h3>
            <!--基本資訊-->
          </template>
          <div class="boxContain c-form">
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.reserveNo')" prop="reserveNo"
                  ><!--單號-->
                  <el-input :disabled="true" :value="reserveItems.reserveNo"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.deltaContactName')" prop="deltaContactName"
                  ><!--台達接洽人-->
                  <el-input :disabled="true" :value="reserveItems.deltaContactName"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.applyDate')" prop="applyDate"
                  ><!--預約日期-->
                  <el-input :disabled="true" :value="reserveItems.applyDate"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.deltaContactNumber')" prop="deltaContactNumber"
                  ><!--接洽人電話-->
                  <el-input :disabled="true" :value="reserveItems.deltaContactNumber"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.applicatorName')" prop="applicatorName"
                  ><!--填單人-->
                  <el-input :disabled="true" :value="reserveItems.applicatorName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.deltaContactMail')" prop="deltaContactMail"
                  ><!--接洽人Mail-->
                  <el-input :disabled="true" :value="reserveItems.deltaContactMail"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <el-collapse-item class="collapsecontent" name="reserve">
          <template slot="title">
            <h3>{{ $t("pages.wording.containForm") }}</h3>
            <!--填單內容-->
          </template>
          <div class="boxContain c-form">
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.oaCode')" prop="OACode"
                  ><!--OA Code-->
                  <el-input :disabled="true" :value="reserveItems.OACode"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.reserveRegion')" prop="reserveRegion"
                  ><!--抵達地區-->
                  <el-input :disabled="true" :value="reserveItems.reserveRegion"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.vendor')" prop="vendor"
                  ><!--公司名稱-->
                  <el-input :disabled="true" :value="reserveItems.vendor"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.reserveArea')" prop="reserveArea"
                  ><!--抵達廠區-->
                  <el-input :disabled="true" :value="reserveItems.reserveArea"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.vendorContactName')" prop="vendorContactName"
                  ><!--廠商聯絡人-->
                  <el-input :disabled="true" :value="reserveItems.vendorContactName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.reserveFactory')" prop="reserveFactory"
                  ><!--抵達廠別-->
                  <el-input :disabled="true" :value="reserveItems.reserveFactory"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.vendorContactListNumber')" prop="vendorContactNumber"
                  ><!--聯絡人電話-->
                  <el-input :disabled="true" :value="reserveItems.vendorContactNumber"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.reserveLocation')" prop="reserveLocation"
                  ><!--抵達地點-->
                  <el-input
                    :disabled="true"
                    :value="$store.getters.getSysCodeText('location', reserveItems.reserveLocation)"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.vendorContactMail')" prop="vendorContactMail"
                  ><!--聯絡人Mail-->
                  <el-input :disabled="true" :value="reserveItems.vendorContactMail"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.reserveArriveDate')" prop="reserveArriveTimes"
                  ><!--預約進廠日期-->
                  <el-input :disabled="true" :value="reserveItems.reserveArriveTimes"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.enterReason')" prop="enterReason"
                  ><!--入廠事由-->
                  <el-input
                    :disabled="true"
                    :value="$store.getters.getSysCodeText('enterReason', reserveItems.enterReason)"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <el-collapse-item class="collapsecontent" name="soTable" v-if="isGenerateByERP">
          <template slot="title">
            <div class="titleBtn">
              <h3>{{ $t("pages.wording.releaseOrderInfo") }}</h3>
            </div>
          </template>
          <div class="boxContain c-form">
            <ReserveSOTable v-if="isGenerateByERP" :reserveID="reserveItems.id" :oaCode="reserveItems.OACode" />
          </div>
        </el-collapse-item>
        <el-collapse-item class="collapsecontent" name="carInfo">
          <template slot="title">
            <div class="titleBtn">
              <h3>{{ $t("pages.wording.carListInfo") }}</h3>
              <!--車輛資訊-->
            </div>
          </template>
          <div class="boxContain c-form">
            <el-row :gutter="24">
              <el-col :span="12">
                <el-radio-group v-model="tmpCarSwitch" class="tmpCarButton" @change="switchTmpCar">
                  <el-radio-button :disabled="carDisable" label="0">{{ $t("pages.wording.originCar") }}</el-radio-button
                  ><!--原定車輛-->
                  <el-radio-button label="1">{{ $t("pages.wording.tmpCar") }}</el-radio-button
                  ><!--臨時車輛-->
                </el-radio-group>
              </el-col>
            </el-row>
            <div class="carInfo" v-if="tmpCarSwitch == 0">
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-form-item
                    :label="$t('pages.wording.driverName')"
                    prop="driverName"
                    :rules="{
                      required: true,
                      message: $t('pages.wording.requiredInput'),
                      trigger: 'blur',
                    }"
                    ><!--駕駛員姓名-->
                    <el-select
                      v-model="dynamicValidateForm.driverName"
                      :placeholder="$t('pages.wording.selectDriverName')"
                      @change="selectedDriver"
                    >
                      <el-option
                        v-for="(items, index) in base.driverNameData"
                        :label="items.driverName"
                        :value="items.driverName"
                        :key="index"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    :label="$t('pages.wording.carPlat')"
                    prop="carPlat"
                    :rules="{
                      required: true,
                      message: $t('pages.wording.requiredInput'),
                      trigger: 'blur',
                    }"
                    ><!--車輛號牌-->
                    <el-select
                      v-model="dynamicValidateForm.carPlat"
                      :placeholder="$t('pages.wording.selectCarPlat')"
                      @change="selectedCarplat"
                    >
                      <el-option
                        v-for="items in base.carPlatData"
                        :label="items.carPlat"
                        :value="items.carPlat"
                        :key="items.carPlat"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-form-item
                    :label="$t('pages.wording.driverID')"
                    prop="driverID"
                    :rules="{
                      required: true,
                      message: $t('pages.wording.requiredInput'),
                      trigger: 'blur',
                    }"
                    ><!--駕駛員證號-->
                    <el-input
                      :value="dynamicValidateForm.driverID"
                      :disabled="true"
                      :placeholder="$t('pages.wording.selectDriverID')"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    :label="$t('pages.wording.carType')"
                    prop="carType"
                    :rules="{
                      required: true,
                      message: $t('pages.wording.requiredInput'),
                      trigger: 'blur',
                    }"
                    ><!--車輛類型-->
                    <el-input
                      :value="$store.getters.getSysCodeText('carType', dynamicValidateForm.carType)"
                      :disabled="true"
                      :placeholder="$t('pages.wording.selectCarType')"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-form-item
                    :label="$t('pages.wording.driverPhone')"
                    prop="driverNumber"
                    :rules="{
                      required: true,
                      message: $t('pages.wording.requiredInput'),
                      trigger: 'blur',
                    }"
                    ><!--駕駛員電話-->
                    <el-input
                      :value="dynamicValidateForm.driverNumber"
                      :disabled="true"
                      :placeholder="$t('pages.wording.selectDriverNumber')"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    :label="$t('pages.wording.carColor')"
                    prop="carColor"
                    :rules="{
                      required: true,
                      message: $t('pages.wording.requiredInput'),
                      trigger: 'blur',
                    }"
                    ><!--車輛顏色-->
                    <el-input
                      :value="$store.getters.getSysCodeText('carColor', dynamicValidateForm.carColor)"
                      :disabled="true"
                      :placeholder="$t('pages.wording.selectCarColor')"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <!--carInfo-->
            <div class="tmpCarInfo" v-if="tmpCarSwitch == 1">
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-form-item
                    :label="$t('pages.wording.tmpDriver')"
                    prop="tmpDriverName"
                    :rules="{
                      required: true,
                      message: $t('pages.wording.requiredInput'),
                      trigger: 'blur',
                    }"
                    ><!--臨時駕駛員姓名-->
                    <el-input
                      v-model="dynamicValidateForm.tmpDriverName"
                      :placeholder="$t('pages.wording.selectTempDriverName')"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    :label="$t('pages.wording.tmpCarPlat')"
                    prop="tmpCarPlat"
                    :rules="{
                      required: true,
                      message: $t('pages.wording.requiredInput'),
                      trigger: 'blur',
                    }"
                    ><!--臨時車輛號牌-->
                    <el-input
                      v-model="dynamicValidateForm.tmpCarPlat"
                      :placeholder="$t('pages.wording.selectTempCarPlat')"
                      :disabled="disabledTempCarPlat"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-form-item
                    :label="$t('pages.wording.tmpDriverID')"
                    prop="tmpDriverID"
                    :rules="[
                      { required: true, message: $t('pages.wording.requiredInput'), trigger: 'blur' },
                      { validator: checkLicienceLength, trigger: 'blur' },
                    ]"
                    ><!--臨時駕駛員證號-->
                    <el-input
                      v-model="dynamicValidateForm.tmpDriverID"
                      :placeholder="$t('pages.wording.selectTempDriverID')"
                      maxlength="6"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    :label="$t('pages.wording.tmpCarType')"
                    prop="tmpCarType"
                    :rules="{
                      required: true,
                      message: $t('pages.wording.requiredInput'),
                      trigger: 'blur',
                    }"
                    ><!--臨時車輛類型-->
                    <el-select
                      v-model="dynamicValidateForm.tmpCarType"
                      :placeholder="$t('pages.wording.selectTempCarType')"
                      @change="changeTempCarType"
                    >
                      <el-option
                        v-for="item in cartypeBase"
                        :label="item[$i18n.locale]"
                        :value="item.code"
                        :key="item.code"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-form-item
                    :label="$t('pages.wording.tmpDriverNum')"
                    prop="tmpDriverNumber"
                    :rules="{
                      required: true,
                      message: $t('pages.wording.requiredInput'),
                      trigger: 'blur',
                    }"
                    ><!--臨時駕駛員電話-->
                    <el-input
                      v-model="dynamicValidateForm.tmpDriverNumber"
                      :placeholder="$t('pages.wording.selectTempDriverNumber')"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    :label="$t('pages.wording.tmpCarColor')"
                    prop="tmpCarColor"
                    :rules="{
                      required: true,
                      message: $t('pages.wording.requiredInput'),
                      trigger: 'blur',
                    }"
                    ><!--臨時車輛顏色-->
                    <el-select
                      v-model="dynamicValidateForm.tmpCarColor"
                      :placeholder="$t('pages.wording.selectTempCarColor')"
                    >
                      <el-option
                        v-for="item in carColorBase"
                        :label="item[$i18n.locale]"
                        :value="item.code"
                        :key="item.code"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <!--tmpCarInfo-->
          </div>
        </el-collapse-item>
        <el-collapse-item class="collapsecontent" name="entourageInfo">
          <template slot="title">
            <div class="titleBtn">
              <h3>{{ $t("pages.wording.entourageInfo") }}</h3>
              <!--隨行人資訊-->
            </div>
          </template>
          <div class="boxContain c-form">
            <div class="c-form-Section-top-right-btn">
              <el-button class="blue-button" icon="el-icon-plus" @click="creatEntourage()" type="primary">{{
                $t("pages.button.creatEntourage")
              }}</el-button
              ><!--新增隨行人員-->
            </div>
            <ul class="boxSection list">
              <li
                v-for="(items, index) in dynamicValidateForm.entourageList"
                :key="index"
                :class="`entourageInfo-${index}`"
              >
                <h4>
                  {{ $t("pages.wording.entourage") }} {{ index + 1
                  }}<!--隨行人-->
                  <span class="deleteIcon" @click="deleteEntourageInfo(index)"><i class="el-icon-delete"></i></span>
                </h4>
                <el-row :gutter="24">
                  <el-col :span="12">
                    <el-form-item
                      :label="$t('pages.wording.entourageName')"
                      :prop="'entourageList.' + index + '.entourageName'"
                      :rules="{
                        required: true,
                        message: $t('pages.wording.requiredInput'),
                        trigger: 'blur',
                      }"
                      ><!--隨行人姓名-->
                      <el-input
                        v-model="items.entourageName"
                        :placeholder="$t('pages.wording.enterEntourageName')"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      :label="$t('pages.wording.entourageID')"
                      :prop="'entourageList.' + index + '.entourageID'"
                      :rules="{
                        required: true,
                        message: $t('pages.wording.requiredInput'),
                        trigger: 'blur',
                      }"
                      ><!--隨行人證號-->
                      <el-input
                        v-model="items.entourageID"
                        maxlength="6"
                        :placeholder="$t('pages.wording.enterEntourageID')"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </li>
            </ul>
            <!--boxSection-->
          </div>
        </el-collapse-item>
        <el-collapse-item class="collapsecontent" name="carringInfo">
          <template slot="title">
            <div class="titleBtn">
              <h3>{{ $t("pages.wording.carringInfo") }}</h3>
              <!--攜帶物資訊-->
            </div>
          </template>
          <div class="boxContain c-form">
            <div class="c-form-Section-top-right-btn">
              <el-button class="blue-button" icon="el-icon-plus" @click="creatCarryItems()" type="primary">{{
                $t("pages.button.creatCarring")
              }}</el-button
              ><!--新增攜帶物-->
            </div>
            <ul class="boxSection list">
              <li
                v-for="(items, index) in dynamicValidateForm.carryItemList"
                :key="index"
                :class="`carryItemInfo-${index}`"
              >
                <h4>
                  {{ $t("pages.wording.carring") }} {{ index + 1 }}
                  <span class="deleteIcon" @click="deleteCarryItemsInfo(index)"><i class="el-icon-delete"></i></span>
                </h4>
                <!--攜帶物-->
                <el-row :gutter="24">
                  <el-col :span="12">
                    <el-form-item
                      :label="$t('pages.wording.carringType')"
                      :prop="'carryItemList.' + index + '.carring'"
                      :rules="{
                        required: true,
                        message: $t('pages.wording.requiredInput'),
                        trigger: 'blur',
                      }"
                      ><!--攜帶物種類-->
                      <el-select
                        v-model="items.carring"
                        :placeholder="$t('pages.wording.placeholderSelect')"
                        @change="selectCarry"
                      >
                        <el-option
                          v-for="item in carringTypeBase"
                          :label="item[$i18n.locale]"
                          :value="item.code"
                          :key="item.code"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      :label="$t('pages.wording.carringNum')"
                      :prop="'carryItemList.' + index + '.carringType'"
                      :rules="{
                        required: true,
                        message: $t('pages.wording.requiredInput'),
                        trigger: 'blur',
                      }"
                      ><!--攜帶物數量-->
                      <el-input-number v-model="items.carringType" :min="1" :max="99"></el-input-number>
                    </el-form-item>
                  </el-col>
                </el-row>
              </li>
            </ul>
            <!--boxSection-->
          </div>
        </el-collapse-item>
      </el-collapse>
      <div class="buttons c-form">
        <el-button class="blue-button" @click="goMyReservationPage" type="primary">{{
          $t("pages.button.cencel")
        }}</el-button
        ><!--取消-->
        <el-button class="blue-button button-right" type="primary" @click="sentApply">{{
          $t("pages.button.send")
        }}</el-button
        ><!--送出-->
      </div>
    </el-form>
    <el-dialog width="35%" :visible.sync="showQRCode" :show-close="false">
      <div slot="title" class="dialog-title">
        <h2>
          <i style="color: #67c23a" class="el-icon-success title-icon"></i>
          {{ $t("pages.wording.reserveFinished") }}
        </h2>
      </div>
      <div class="qrcode-body" v-html="qrCodeHtml"></div>
      <article class="qrcode-hint">
        {{ $t("pages.wording.useQRCodeHint") }}
      </article>
      <div slot="footer" class="dialog-footer" style="margin-top: -2em">
        <el-button type="primary" @click="goMyReservationPage">OK</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import { store } from "@/store/store"
import { api } from "@/utils/api.js"
import { utils, IsFullTypeChar } from "@/utils/utils.js"
import ReserveSOTable from "@/components/Reserve/ReserveSOTable"

export default {
  name: "PageMyReservationForm",
  components: {
    ReserveSOTable,
  },
  props: ["id", "parentName", "parent"],
  data() {
    return {
      reserveItems: {
        id: -1,
        reserveNo: "",
        deltaContactNT: "",
        deltaContactName: "",
        deltaContactNumber: "",
        deltaContactDept: "",
        deltaContactMail: "",
        applyDate: "",
        applicatorName: "",
        applicatorNT: "",
        applicatorMail: "",
        OACode: "",
        reserveRegion: "",
        vendor: "",
        reserveArea: "",
        vendorContactName: "",
        reserveFactory: "",
        vendorContactNumber: "",
        reserveLocation: "",
        vendorContactMail: "",
        reserveArriveTimes: "",
        enterReason: "",
      },
      dynamicValidateForm: {
        driverName: "",
        driverID: "",
        carPlat: "",
        driverNumber: "",
        carType: "",
        carColor: "",
        tmpDriverName: "",
        tmpDriverID: "",
        tmpCarPlat: "",
        tmpDriverNumber: "",
        tmpCarType: "",
        tmpCarColor: "",
        tempCar: false,
        carryItemList: [],
        entourageList: [],
      },
      base: {
        driverNameData: [],
        carPlatData: [],
      },
      tmpCarSwitch: 0,
      carDisable: false,
      reserveInfo: {},
      alertMessageCb: {},
      alertMessage: {},
      isGenerateByERP: false,
      activeShowBlock: ["basic", "reserve", "soTable", "carInfo", "entourageInfo", "carringInfo"],
      qrCodeHtml: null,
      showQRCode: false,
      disabledTempCarPlat: false,
      cartypeBase: [],
      carColorBase: [],
      carringTypeBase: [],
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    ...mapGetters(["getUserLoginData"]),
    init() {
      const id = this.$props.id === undefined ? this.$route.query.id : this.$props.id
      this.getReserveInfo(id)
    },
    setERPONE() {
      //ERP一次性客戶處理
      if (this.reserveItems.reserveType != "ERP_ONE") return
      this.tmpCarSwitch = 1
      this.carDisable = true
    },
    getVendorInfo(datas) {
      const parameter = {
        oacode: datas.OACode,
        area: datas.reserveArea,
      }
      this.$store.dispatch("getVendorInfo", { params: parameter })
    },
    selectedDriver(val) {
      const vm = this
      this.base.driverNameData.forEach((item, index) => {
        if (val == item.driverName) {
          vm.dynamicValidateForm.driverID = item.driverLicience
          vm.dynamicValidateForm.driverNumber = item.driverNumber
        }
      })
    },
    selectedCarplat(val) {
      const vm = this
      this.base.carPlatData.forEach((item, index) => {
        if (val == item.carPlat) {
          vm.dynamicValidateForm.carType = item.carType
          vm.dynamicValidateForm.carColor = item.carColor
        }
      })
    },
    selectCarry(val) {
      const vm = this
      let i = 0
      this.dynamicValidateForm.carryItemList.forEach((item, index) => {
        if (val == item.carring) {
          if (i > 0) {
            vm.deleteCarryItemsInfo(index)
            utils.alertMessage(vm, 0, "carryDuplicate", "information")
          }
          i++
        }
      })
    },
    switchTmpCar() {
      if (this.tmpCarSwitch == 0) {
        this.dynamicValidateForm.tmpDriverName = ""
        this.dynamicValidateForm.tmpDriverID = ""
        this.dynamicValidateForm.tmpDriverNumber = ""
        this.dynamicValidateForm.tmpCarPlat = ""
        this.dynamicValidateForm.tmpCarType = ""
        this.dynamicValidateForm.tmpCarColor = ""
      } else {
        this.dynamicValidateForm.driverName = ""
        this.dynamicValidateForm.driverID = ""
        this.dynamicValidateForm.carPlat = ""
        this.dynamicValidateForm.driverNumber = ""
        this.dynamicValidateForm.carType = ""
        this.dynamicValidateForm.carColor = ""
      }
    },
    getReserveInfo(id) {
      this.$store.dispatch("getReserveInfo", { params: { id: id } })
    },
    async openReserveQRCodeDialog() {
      try {
        const { data } = await api.apiGetReserveQRCode(this.reserveItems.reserveNo, this.reserveItems.id)
        this.qrCodeHtml = data
        this.showQRCode = true
      } catch(error) {
        console.error(error)
      }
    },
    goMyReservationPage() {
      this.$router.push({ path: "/MyReservation" })
    },
    buildCarringInfo(data) {
      this.dynamicValidateForm.carryItemList = data
    },
    buildEntourageInfo(data) {
      this.dynamicValidateForm.entourageList = data
    },
    buildReserveInfo(data) {
      this.reserveInfo = data

      this.reserveItems.id = data.id
      this.reserveItems.OACode = data.OACode
      this.reserveItems.reserveNo = data.reserveNo
      this.reserveItems.reserveType = data.reserveType
      this.reserveItems.applyDate = utils.getFormateDateTime("Date", data.applyDatetime)
      this.reserveItems.deltaContactNT = data.deltaContactNT
      this.reserveItems.deltaContactNumber = data.deltaContactNumber
      this.reserveItems.deltaContactMail = data.deltaContactMail
      this.reserveItems.deltaContactName = data.deltaContactName
      this.reserveItems.deltaContactDept = data.deltaContactDept

      this.reserveItems.applicatorName = data.applicatorName
      this.reserveItems.applicatorNT = data.applicatorNT
      this.reserveItems.applicatorMail = data.applicatorMail

      this.reserveItems.reserveRegion = data.reserveRegion
      this.reserveItems.reserveArea = data.reserveArea
      this.reserveItems.reserveFactory = data.reserveFactory
      this.reserveItems.vendor = data.vendor
      this.reserveItems.vendorContactName = data.vendorContactName
      this.reserveItems.vendorContactNumber = data.vendorContactNumber
      this.reserveItems.vendorContactMail = data.vendorContactMail
      this.reserveItems.reserveLocation = data.reserveLocation
      this.reserveItems.reserveArriveTimes = utils.getFormateDateTime("DateTime", data.reserveArriveDatetime)
      this.reserveItems.enterReason = data.enterReason

      this.dynamicValidateForm.driverName = data.driverName
      this.dynamicValidateForm.driverID = data.driverID
      this.dynamicValidateForm.driverNumber = data.driverNumber
      this.dynamicValidateForm.carPlat = data.carPlat
      this.dynamicValidateForm.carType = data.carType
      this.dynamicValidateForm.carColor = data.carColor

      this.dynamicValidateForm.tmpDriverName = data.tmpDriverName
      this.dynamicValidateForm.tmpDriverID = data.tmpDriverID
      this.dynamicValidateForm.tmpDriverNumber = data.tmpDriverNumber
      this.dynamicValidateForm.tmpCarPlat = data.tmpCarPlat
      this.dynamicValidateForm.tmpCarType = data.tmpCarType
      this.dynamicValidateForm.tmpCarColor = data.tmpCarColor

      this.isGenerateByERP = this.reserveItems.reserveType === "ERP" || this.reserveItems.reserveType === "ERP_ONE"
      this.changeTempCarType()
      this.setERPONE()
      this.getCarColorBase()
      this.getCartypeBase()
      this.getCarringTypeBase()
    },
    creatEntourage() {
      if (this.dynamicValidateForm.entourageList.length >= 2) {
        alert("two items is max.")
        return
      }
      const newEntourageList = {
        id: 0,
        reserveRef: this.$props.id,
        entourageName: "",
        entourageID: "",
      }
      this.dynamicValidateForm.entourageList.push(newEntourageList)
    },
    deleteEntourageInfo(raw) {
      this.dynamicValidateForm.entourageList.splice(raw, 1)
    },
    creatCarryItems() {
      if (this.dynamicValidateForm.carryItemList.length >= 4) {
        alert("four items is max.")
        return
      }
      const newCarryItemList = {
        id: 0,
        reserveRef: this.$props.id,
        carring: "",
        carringType: 0,
      }
      this.dynamicValidateForm.carryItemList.push(newCarryItemList)
    },
    deleteCarryItemsInfo(raw) {
      this.dynamicValidateForm.carryItemList.splice(raw, 1)
    },
    checkLicienceLength(rule, value, callback) {
      if (value.length < 6) {
        callback(new Error(this.$t("validateWarning.lenRequred", { len: "6" })))
      } else {
        callback()
      }
    },
    changeTempCarType() {
      if (this.dynamicValidateForm.tmpCarType === "Tricycle") {
        this.disabledTempCarPlat = true
        this.dynamicValidateForm.tmpCarPlat = this.$t("pages.wording.placeholderAutoGenerate")
      } else {
        let nowDisabledTempCarPlat = this.disabledTempCarPlat
        this.disabledTempCarPlat = false
        if (nowDisabledTempCarPlat === true) {
          this.dynamicValidateForm.tmpCarPlat = null
        }
      }
    },
    sentApply() {
      const vm = this
      this.$refs["dynamicValidateForm"].validate((valid) => {
        if (valid) {
          const originReserveData = vm.reserveInfo
          vm.dynamicValidateForm.tempCar = vm.tmpCarSwitch == 0 ? false : true

          var sentReserveData = {
            id: vm.$props.id,
            reserveNo: originReserveData.reserveNo,
            reserveStatus: "entering",
            updateDatetime: utils.getISOString("now"),
            applyDate: utils.getFormateDateTime("Date", originReserveData.applyDatetime),
            applyDatetime: originReserveData.applyDatetime,
            applicatorName: originReserveData.applicatorName,
            applicatorMail: originReserveData.applicatorMail,
            applicatorNT: originReserveData.applicatorNT,
            deltaContactName: originReserveData.deltaContactName,
            deltaContactNT: originReserveData.deltaContactNT,
            deltaContactNumber: originReserveData.deltaContactNumber,
            deltaContactMail: originReserveData.deltaContactMail,
            deltaContactDept: originReserveData.deltaContactDept,
            OACode: originReserveData.OACode,
            vendor: originReserveData.vendor,
            enterReason: originReserveData.enterReason,
            vendorContactName: originReserveData.vendorContactName,
            vendorContactNumber: originReserveData.vendorContactNumber,
            vendorContactMail: originReserveData.vendorContactMail,
            reserveArriveDate: utils.getFormateDateTime("Date", originReserveData.reserveArriveDate),
            reserveArriveTime: utils.getFormateDateTime("Time", originReserveData.reserveArriveTime),
            reserveArriveDatetime: originReserveData.reserveArriveDatetime,
            reserveRegion: originReserveData.reserveRegion,
            reserveArea: originReserveData.reserveArea,
            reserveFactory: originReserveData.reserveFactory,
            reserveLocation: originReserveData.reserveLocation,
            driverName: vm.dynamicValidateForm.driverName,
            driverID: vm.dynamicValidateForm.driverID,
            driverNumber: vm.dynamicValidateForm.driverNumber,
            carPlat: vm.dynamicValidateForm.carPlat,
            carType: vm.dynamicValidateForm.carType,
            carColor: vm.dynamicValidateForm.carColor,
            tempCar: vm.dynamicValidateForm.tempCar,
            reserveType: originReserveData.reserveType,
            customerCode: originReserveData.customerCode,
            groupCode: originReserveData.groupCode,
          }

          if (vm.dynamicValidateForm.tempCar) {
            sentReserveData.tmpDriverName = vm.dynamicValidateForm.tmpDriverName
            sentReserveData.tmpDriverID = vm.dynamicValidateForm.tmpDriverID
            sentReserveData.tmpDriverNumber = vm.dynamicValidateForm.tmpDriverNumber
            sentReserveData.tmpCarPlat = vm.dynamicValidateForm.tmpCarPlat
            sentReserveData.tmpCarType = vm.dynamicValidateForm.tmpCarType
            sentReserveData.tmpCarColor = vm.dynamicValidateForm.tmpCarColor
            if (IsFullTypeChar(sentReserveData.tmpCarPlat)) {
              utils.alertMessage(vm, 1, vm.$t("message.alert.notAcceptFullType"), vm.$t("message.title.warn"))
              return
            }
          }
          const params = {
            reserveType: sentReserveData.reserveType,
            reserveID: sentReserveData.id,
            inputJsonObject: {
              reserveData: sentReserveData,
              carringData: vm.dynamicValidateForm.carryItemList,
              entourageData: vm.dynamicValidateForm.entourageList,
              logOperator: this.getUserLoginData().userName,
            },
            updateUser: this.getUserLoginData().userName,
          }
          utils.showLoading(vm)
          api
            .apiUpdateReserveInfo(params)
            .then((response) => {
              utils.closeLoading(vm)
              if (response.data) {
                const { success, messageCode } = response.data
                if (success) vm.openReserveQRCodeDialog()
                else utils.alertMessage(vm, 1, vm.$t("message.alert.backend." + messageCode))
              } else {
                utils.alertMessage(vm, 1, vm.$t("message.alert.submitFail"))
              }
            })
            .catch((error) => {
              console.error(error)
            })
        } else {
          utils.alertMessage(vm, 1, vm.$t("message.alert.checkFormDataCorrect"))
          return false
        }
      })
    },
    back() {
      var parent = this.$props.parentName
      var parameter = { back: true }

      if (parent == "searchReserve") {
        this.$router.push({
          name: "NewPageSearchReservation",
          params: parameter,
        })
      }
    },
    async getCartypeBase() {
      this.cartypeBase = await utils.getCodeListWithCulture(
        this.reserveItems.reserveRegion,
        this.reserveItems.reserveArea,
        "cartype"
      )
    },
    async getCarColorBase() {
      this.carColorBase = await utils.getCodeListWithCulture(
        this.reserveItems.reserveRegion,
        this.reserveItems.reserveArea,
        "carColor"
      )
    },
    async getCarringTypeBase() {
      this.carringTypeBase = await utils.getCodeListWithCulture(
        this.reserveItems.reserveRegion,
        this.reserveItems.reserveArea,
        "carringType"
      )
    },
  },
  watch: {
    "$store.getters.alertMessage": function (val) {
      const code = val.code
      const message = val.message
      const cb = val.cb
      const title = "information"
      if (val.result != undefined) {
        this.alertMessage.result = val.result
      }
      utils.alertMessage(this, code, message, title, cb)
    },
    "$store.getters.reserveInfo": function (datas) {
      this.buildReserveInfo(datas.result.reserveData)
      this.buildCarringInfo(datas.result.carringData)
      this.buildEntourageInfo(datas.result.entourageData)

      //get entourage list
      this.getVendorInfo(datas.result.reserveData)
    },
    "$store.getters.carDataInfo": function (data) {
      if(!data){
        return
      }
      const newData = data.filter((item) => item.available == true)
      this.base.carPlatData = newData
    },
    "$store.getters.driverDataInfo": function (data) {
      if(!data){
        return
      }
      const newData = data.filter((item) => item.available == true)
      this.base.driverNameData = newData
    },
  },
}
</script>

<style>
.c-form.boxContain {
  background-color: #fff;
  padding: 25px 25px 5px 25px;
  margin: 20px 0px;
  border-width: 0px 5px;
  border-style: solid;
  border-radius: 4px;
  border-color: #00a0e9;
}
.c-form .el-row {
  font-size: 16px;
  line-height: 50px;
  box-sizing: border-box;
}
.c-form .el-form-item {
  font-size: 14px;
}
.c-form-Section-top-right-btn {
  text-align: right;
}
.tmpCarButton {
  margin: 20px 10px;
}
</style>
